import React from 'react';

const initiateAffirm = () => {
  window.affirm?.ui?.ready?.(() => {
    window.affirm.ui.refresh();
  });
};
export const useAffirm = () => {
  React.useEffect(() => {
    if (window.affirm) {
      initiateAffirm();
    } else {
      const timeout = setTimeout(initiateAffirm, 500);
      return () => clearTimeout(timeout);
    }
  });
};
